export default __webpack_public_path__ + "static/media/24.c2fd2e85.webp";